import {Repo} from "@services/repos/vendors/repo";
import {AxiosPromise} from "axios";
import { ICurrency } from "@/interfaces/models/currency";
import { _CONST } from '@/constants/constants';

export class BitflowCurrencyRepo extends Repo{
  constructor() {
    super('bitflowCurrency');
  }

  getList(): AxiosPromise | any {
    let query = {
      ...this.getDefaultQuery(),
    };
    return this.http.get(this.getPath('get-list'), this.convertToUrlParams(query));
  }

  get(currencyId: string): AxiosPromise {
    let query = {
      ...this.getDefaultQuery(),
      currencyId
    };
    return this.http.get(this.getPath("get"), this.convertToUrlParams(query));
  }

  update(query: any): AxiosPromise {
    return this.http.post(this.getPath("update"), query);
  }

  getCoin(coin: string): AxiosPromise {
    return this.http.get(this.getPath(coin));
  }

  setCoin(query: any): AxiosPromise {
    return this.http.post(this.getPath(query.id), query);
  }

}
